import { Injectable } from "@angular/core";
import * as _ from "lodash";

@Injectable({
  providedIn: "root",
})
export class SortArrayService {
  constructor() {}

  /**
   *
   * @param items object[]
   * @param keys ["NameKey","NameKey2"]
   * @param orders ["asc", "desc"]
   * @returns
   */
  orderBy(items: any[], keys: (string | ((item: any) => any))[], orders: any[]) {
    return _.orderBy(items, keys, orders);
  }

  sortByDate(items: any[], key: string, order: "asc" | "desc") {
    return _.orderBy(items, key, order);
  }
}
